
(function documentEditControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentEditController', [
            '$filter', '$state', '$scope', '$stateParams', '$translate', 'errorsExtend', 'processCustomerService', 'fileWorkflowService', 'authExtend', 'configViewService', 'profileCertificateService', '$parse', '$q', 'config',
            function documentEditController($filter, $state, $scope, $stateParams, $translate, errors, processCustomerService, fileWorkflowService, auth, configViewService, profileCertificateService, $parse, $q, config) {

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.tmpProcess = {
                    name: '',
                    metadatas: []
                };

                $scope.legend = { type: 'warning', message: 'NoCertificateAvailable' };
                $scope.callbackUrl = '#/Document/Find/SignPending';

                $scope.setDocument = function (document) {
                    $scope.document = document;
                    return configViewService.getById('CPPDocument');
                };

                $scope.loadConfig = function (config) {
                    $scope.configView = config;

                    var certificateFilters = {
                        organizationalUnitId: $scope.document.organizationalUnitId,
                        enabled: true,
                        active: true,
                        type: 0, // Empleado
                        signType: 0 // Firma simple
                    };

                    return profileCertificateService.get(certificateFilters);
                };

                $scope.setConfig = function (certificates) {
                    var metadatas = [];

                    var resultProcessType = $filter('filter')($scope.configView.processTypes, { processTypeId: $scope.document.documentTypeId }, true);
                    if (resultProcessType.length == 0) {
                        $scope.document.metadataValues = metadatas;
                        return;
                    }

                    resultProcessType[0].metadatas.forEach(function (documentMetadata) {
                        if (documentMetadata.editCriteria) {
                            var metadataFound = $filter('filter')($scope.document.metadataValues, { systemName: documentMetadata.systemName }, true);

                            var value = null;
                            var desc = null;
                            var isVisible = documentMetadata.systemName !== '_idCertificado' && documentMetadata.systemName !== '_cpassword' && documentMetadata.systemName !== '_estrec';

                            if (metadataFound.length > 0) {
                                value = metadataFound[0].value;
                                desc = metadataFound[0].description;
                            }

                            $scope.tmpProcess.metadatas.push({
                                idObject: $scope.document.id + '' + documentMetadata.metadataId,
                                metadataId: documentMetadata.metadataId,
                                metadataType: documentMetadata.metadataType.toLowerCase(),
                                metadataLabel: documentMetadata.editCriteria.name,
                                metadataIsRequired: documentMetadata.editCriteria.isRequired && isVisible,
                                metadataIsVisible: isVisible,
                                metadataReadOnly: !documentMetadata.editCriteria.isEditable,
                                metadataEnabled: documentMetadata.editCriteria.isEditable,
                                maskOptions: documentMetadata.maskOptions,
                                metadataValue: value,
                                metadataOptions: documentMetadata.metadataOptionValues,
                                systemName: documentMetadata.systemName,
                                order: documentMetadata.editCriteria.order
                            });
                        }
                    });

                    if (certificates.length > 0) {
                        $scope.addCertificateMetadata(certificates);
                    } else {
                        $scope.signNoCertificate = true;
                    }

                    $scope.tmpProcess.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    var item = {};

                    $scope.document.files.forEach(function (file) {
                        item.creationDate = file.creationDate;
                        item.name = file.name;
                        item.size = file.size;
                        item.id = file.id;
                        item.stream = null;
                    });
                    $scope.previewFile(item, 0);
                };

                $scope.loadFile = function (fileId) {
                    return fileWorkflowService.getById(fileId)
                };

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileWorkflowService.preview(item, true).then(function (result) {
                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            errors.showError(error);
                            //$scope.hidePreview();
                        }
                    });
                };

                $scope.showDisagreement = function (value) {
                    $scope.disagreementIsVisible = value;
                    $scope.disagreementMotive = $scope.showMotiveDisagreement ? '' : undefined;
                };

                $scope.cancel = function () {
                    if (!$scope.disagreementIsVisible) {
                        $state.go('document-detail', { id: $stateParams.id });
                    }

                    $scope.showDisagreement(false);
                };

                $scope.execute = function () {
                    if (!$scope.documentEdit.$valid) {
                        $scope.documentEdit.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if (!$scope.selectedCertificate.action) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    var method = $parse($scope.selectedCertificate.action);

                    if (!method($scope)) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    return method($scope)();
                };

                $scope.signEncode = function () {
                    $scope.tmpProcess.metadatas.forEach(function (tmpProcessMetadata) {
                        var metadataFound = $filter('filter')($scope.document.metadataValues, { metadataId: tmpProcessMetadata.metadataId }, true);

                        if (tmpProcessMetadata.systemName === '_estrec') {
                            tmpProcessMetadata.metadataValue = $scope.disagreementIsVisible ? 'NC' : 'C';
                        }

                        if (metadataFound.length === 1) {
                            metadataFound[0].value = tmpProcessMetadata.metadataValue;
                        } else if (metadataFound.length === 0) {
                            $scope.document.metadataValues.push({
                                metadataId: tmpProcessMetadata.metadataId,
                                name: tmpProcessMetadata.metadataLabel,
                                isRequired: tmpProcessMetadata.metadataIsRequired,
                                isVisible: tmpProcessMetadata.metadataIsVisible,
                                order: tmpProcessMetadata.order,
                                systemName: tmpProcessMetadata.systemName,
                                type: tmpProcessMetadata.metadataType,
                                value: tmpProcessMetadata.metadataValue
                            });
                        }
                    });

                    return processCustomerService.modifyAndSend($scope.document).then(function () {
                        $state.go('document-find');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.controlChanged = function (metadata) {
                    if (metadata.systemName === '_wcertificate') {
                        var selectedOption = $filter('filter')(metadata.metadataOptions, { value: metadata.metadataValue }, true);
                        if (selectedOption.length === 1) {
                            $scope.selectedCertificate = selectedOption[0];
                            $scope.disagreementIsEnabled = $scope.selectedCertificate.supportDisagreement;
                            $scope.isNacion = $scope.selectedCertificate.description === 'Nacion';
                            $scope.certId = $scope.selectedCertificate.id;

                            angular.forEach($scope.tmpProcess.metadatas, function (m) {
                                if (m.systemName === '_cpassword') {
                                    m.metadataIsVisible = $scope.selectedCertificate.requirePassword;
                                    m.metadataIsRequired = $scope.selectedCertificate.requirePassword;
                                    m.metadataValue = undefined;
                                }

                                if (m.systemName === '_idCertificado') {
                                    m.metadataValue = $scope.selectedCertificate.id;
                                }
                            });
                        }
                    }

                    if (metadata.systemName === '_motivodisc') {
                        $scope.disagreementMotive = metadata.metadataValue;
                    }
                };

                $scope.showError = function (error) {
                    errors.showError(error);
                    $scope.cancel();
                };

                $scope.addCertificateMetadata = function (certificates) {
                    var metadataCertificates = {
                        idObject: $scope.document.id + '_wcertificate',
                        systemName: '_wcertificate',
                        metadataType: 'radio',
                        metadataLabel: 'Certificado',
                        metadataIsVisible: certificates.length > 1,
                        metadataEnabled: certificates.length > 1,
                        metadataIsRequired: true,
                        metadataValue: undefined,
                        order: 0,
                        metadataOptions: []
                    };

                    angular.forEach(certificates, function (certificate) {
                        var description = certificate.provider;
                        if (certificate.expirationDate) {
                            description = certificate.provider + ' (' + $filter('date')(certificate.expirationDate, 'dd/MM/yyyy') + ')';
                        }

                        metadataCertificates.metadataOptions.push({
                            id: certificate.id,
                            value: certificate.id,
                            description: description,
                            requirePassword: certificate.requirePassword,
                            supportDisagreement: certificate.supportDisagreement,
                            action: certificate.singleSignatureAction
                        });
                    });

                    if (metadataCertificates.metadataOptions.length === 1) {
                        metadataCertificates.metadataValue = metadataCertificates.metadataOptions[0].value;
                        $scope.controlChanged(metadataCertificates);
                    }

                    $scope.tmpProcess.metadatas.push(metadataCertificates);
                };

                $scope.load = function () {
                    $scope.userId = auth.getUserId();
                    $scope.signPermission = auth.isInRole('DOCUMENTCUSTOMER SIGN');
                    //$scope.showMotiveDisagreement = false;
                    $scope.disagreementIsVisible = false;
                    $scope.disagreementIsEnabled = false;

                    processCustomerService.checkout($stateParams.id)
                        .then($scope.setDocument, $scope.showError)
                        .then($scope.loadConfig, $scope.showError)
                        .then($scope.setConfig, $scope.showError);
                };

                $scope.signLakaut = function () {
                    $scope.isInProgress = true;

                    $scope.signFileLakaut().then(function () {
                        $scope.isInProgress = false;
                        $state.go('document-find');
                    }, function (error) {
                        $scope.isInProgress = false;
                        errors.showError(error);
                    });
                };

                $scope.signFileLakaut = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;
                    var certificateTypeId = 0; // Empleado

                    fileWorkflowService.share($stateParams.id, certificateTypeId).then(function (response) {
                        // Create the outputURl
                        var output = config.apiUrl("SignedLakautCallback", 'wf');
                        profileCertificateService.certicateLakautSign(response, output, $scope.document.organizationalUnitId).then(function (responseSign) {
                            defered.resolve();
                        }, function (error) {
                            defered.reject(error);
                        });

                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                }

                $scope.load();
            }
        ]);
})();
